













import { Component, Vue } from 'vue-property-decorator';

import { version } from '../package.json';

@Component
export default class App extends Vue {
  home() {
    this.$router.replace({ path: '/', replace: true });
  }

  get year() {
    return new Date().getFullYear();
  }

  get version() {
    return version;
  }
}
